import { create } from 'zustand';

export type ModalType = 'create' | 'edit' | 'confirm' | 'message' | 'delete' | '';

interface ModalData {
  id?: number;
  title?: string;
  message?: string;
  action?: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'danger' | 'primary';
  onConfirm?: () => void;
  [key: string]: any;
}

interface ModalState {
  type: ModalType;
  data: ModalData;
  isOpen: boolean;
  openModal: (type: ModalType, data?: ModalData) => void;
  closeModal: () => void;
  updateModalData: (data: Partial<ModalData>) => void;
}

const initialState = {
  type: '' as ModalType,
  data: {},
  isOpen: false,
};

export const useModalStore = create<ModalState>()((set) => ({
  ...initialState,
  openModal: (type, data = {}) => set({ type, data, isOpen: true }),
  closeModal: () => set(initialState),
  updateModalData: (data) => set((state) => ({
    ...state,
    data: { ...state.data, ...data },
  })),
}));